var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"food-info-button-container",on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.$t('overview', 'sweetInfoButtonText'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }